// Boshliq (2026-09-05): headerdagi foydalanish muddati «batareykasi»ni yoqish/o'chirish — TIZIM sozlamasi (mainTenant.ShowSubscriptionBattery), default YOQILGAN.
// Faqat hamkor tizimlari (magazin/kontragent, tenant > 1) — SAV'da batareyka yo'q. Saqlangach MyPermissions qayta o'qiladi (crm-refresh-perms).
import React from "react"
import { Space, Switch, Typography, message } from "antd"
import { useTranslation } from "react-i18next"
import { useMutation, useQuery } from "@tanstack/react-query"
import { request } from "../../../../utils/config"

const GET_BAT = async () => (await request({ url: "Tenants/SubscriptionBattery", method: "GET" })).data
const SET_BAT = async (enabled: boolean) => (await request({ url: "Tenants/SetSubscriptionBattery", method: "POST", params: { enabled } })).data

export default function SubscriptionBatterySwitch() {
  const { t } = useTranslation()
  const { data, refetch, isLoading } = useQuery(["GET_SUB_BATTERY"], GET_BAT, { staleTime: 60000 })
  const enabled = data?.enabled !== false   // default yoqilgan
  const { mutate: save, isLoading: saving } = useMutation(SET_BAT, {
    onSuccess: () => { refetch(); window.dispatchEvent(new Event("crm-refresh-perms")); message.success(t("subBatterySaved")) },
    onError: () => message.error(t("error")),
  })
  return (
    <Space direction="vertical" size={4}>
      <Switch checked={enabled} loading={isLoading || saving} onChange={(v) => save(v)} checkedChildren={"🔋 " + t("subBatteryOn")} unCheckedChildren={t("subBatteryOff")} />
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>{t("subBatteryHint")}</Typography.Text>
    </Space>
  )
}
